import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { ResyncVacanciesResponse } from "./types";

import { decodeSlug } from "@/features/integrations/utils/slug";
import { instance } from "@/lib/axios/instance";
import useToast from "@/lib/hooks/useToast";

type ProblemDetails = {
  detail?: string;
  title?: string;
  status?: number;
  error?: string;
  code?: string;
};

export function useResyncVacancies({
  integrationName,
}: {
  integrationName: string;
}) {
  const { showToast } = useToast();
  const { t } = useTranslation();

  return useMutation<
    ResyncVacanciesResponse,
    AxiosError<ProblemDetails>,
    { clientId: string }
  >({
    mutationFn: ({ clientId }) => {
      return instance
        .post<ResyncVacanciesResponse>(
          `/api/v2/Integrations/${integrationName}/job-sync/Vacancies/Resync?clientId=${clientId}`
        )
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      showToast(data.message, "success");
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.detail ||
        t(`integrations.modules.names.${decodeSlug(integrationName)}`);
      showToast(errorMessage, "error");
    },
  });
}
